import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Icon from "module-common/Icon";
import Avatar from "module-common/Avatar";
import LabelList from "module-common/label-list/LabelList";
import { CaseManagementStore } from "../../../Store";

export default class Row extends Component {
  static propTypes = {
    name: PropTypes.string,
    channelName: PropTypes.string,
    avatar: PropTypes.string,
    channel: PropTypes.string,
    summary: PropTypes.string,
    selected: PropTypes.bool,
    labels: PropTypes.array,
    timestamp: PropTypes.object,
    serverTime: PropTypes.object,
    showIndicator: PropTypes.bool,
    status: PropTypes.string,
    needApproval: PropTypes.bool,
    onClick: PropTypes.func,
    messageTo: PropTypes.string,
    color: PropTypes.string,
    channelSignatureActive: PropTypes.bool
  };
  static defaultProps = {
    name: "Full Name",
    channelName: "channelname",
    summary: "",
    selected: false,
    labels: [],
    timestamp: null,
    status: "normal",
    serverTime: null,
    needApproval: false
  };

  render() {
    const props = this.props;
    const { selectedTab } = CaseManagementStore
    const showToolbar = selectedTab === 'all' && props.progressType === 'OPEN'
    // decide row color
    let indicator;
    let background;
    switch (props.status) {
      case "alert":
        background = "alertCaseBackground";
        indicator = "alertCaseIndicator";
        break;
      case "warning":
        indicator = "warningCaseIndicator";
        break;
      case "normal":
        indicator = "normalCaseIndicator";
        break;
      default:
    }

    // hide indicator if needed
    if (!props.showIndicator) indicator = "transparent";

    return (
      <Wrapper
        onClick={props.onClick}
        selected={props.selected}
        color={background}
      >
        {indicator && <Indicator color={indicator} />}
        <Avatar image={props.avatar} channel={props.channel} />
        <RightColumn>
          <FullName>{props.name}</FullName>
          <ChannelName>@{props.channelName}</ChannelName>
          <LabelList labels={props.labels} />
          <Summary>{props.summary}</Summary>
        </RightColumn>
        <Metadata>
          {props.timestamp && (
            <Time>
              {props.timestamp.from(props.serverTime)}
              {props.channelSignatureActive && (
                <MessageTo colorTo={"#" + props.color}>
                  {props.messageTo}
                </MessageTo>
              )}
            </Time>
          )}
          {props.needApproval && <Icon name="clock-blue" />}
        </Metadata>
        {showToolbar && <Toolbar>
          <AssignToMe onClick={props.onAssignToMe}>
            Assign to me
          </AssignToMe>
        </Toolbar>}      
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex: none;
  flex-direction: row;
  align-items: center;
  height: 100px;
  padding-left: 10px;
  cursor: pointer;
  transition: 0.3s;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  &:hover {
    background-color: ${props => props.theme.moduleBackground};
  }
  ${props => props.color && `background-color: ${props.theme[props.color]};`};
  ${props =>
    props.selected && `background-color: ${props.theme.moduleBackground};`};
`;
const Indicator = styled.div`
  flex: none;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  margin-right: 8px;
  background-color: ${props => props.theme[props.color]};
`;
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px;
  margin-left: 6px;
  overflow: hidden;
`;
const FullName = styled.div`
  font-size: 1rem;
  font-weight: bold;
`;
const ChannelName = styled.div`
  font-size: 0.9rem;
  color: ${props => props.theme.uiText};
`;
const Summary = styled.div`
  font-size: 1rem;
  overflow: hidden;
  height: 3rem;
  word-break: break-word;
`;
const Metadata = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const Time = styled.div`
  /* margin-right: 6px; */
  font-size: 0.7rem;
  color: ${props => props.theme.uiText};
  display: flex;
`;

const MessageTo = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  padding: 2px 6px;
  border: 1px solid ${props => props.colorTo};
  margin-left: 5px;
  align-items: center;
  display: flex;
  justify-content: center;
  color: #ffffff;
  text-transform: uppercase;
  background: ${props => props.colorTo};
`;

const Toolbar = styled.div`
  position: absolute;
  height: 25px;
  bottom: 0;
  width: 100%;
  justify-content: flex-end;
  padding-right: 35px;
  padding-bottom: 5px;
  display: flex;
`

const AssignToMe = styled.button`
  padding: 1px;
  border: 1px solid #fff;
  border-radius: 4px;
  color: white;
  font-weight: 700;
  cursor: pointer;
  background-color: ${props => props.theme.blueButton};
  &:focus {
    outline: none;
  }
  &:hover {
    background: white;
    color: ${props => props.theme.blueButton};
}
  padding: 0 2px;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/list-panel/list/Row.js